<template>
  <div class="custom-input-wrapper">
    <label :for="labelFor" v-if="showLabel">
      {{ label }}
      <span v-if="showRequiredSign">*</span>
    </label>
    <input
      :id="labelFor"
      :class="{ 'input-invalid': isInvalid }"
      :disabled="isDisabled"
      :aria-required="showRequiredSign"
      :placeholder="placeholder"
      :value="value"
      v-on:input="
        (e) => {
          e.preventDefault()
          // TODO: Add Debouncing
          handleFormInput(e.target.value)
        }
      "
      v-on:blur="handleOnFocusOut"
      v-on:keyup="handleOnKeyUp"
      style="width: 100%"
      :aria-invalid="isInvalid"
    />
  </div>
</template>

<script>
export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true
    },
    showRequiredSign: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Enter text'
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Input',
      required: true
    },
    labelFor: {
      type: String,
      default: ''
    },
    handleFormInput: Function,
    handleOnFocusOut: {
      type: Function,
      default: () => {}
    },
    handleOnKeyUp: {
      type: Function,
      default: () => {}
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
.custom-input-wrapper {
  width: 100%;
}
label {
  font-size: 14px;
  color: #757575;
  font-weight: 400;
  margin: 0 0 4px;
  padding: 0;
  display: flex;
  align-items: flex-start;
  padding-bottom: 3px;
  line-height: 17.5px;
  span {
    color: #00203e;
    font-size: 12px;
    font-weight: 300;
    margin: 0 0 0 2px;
  }
}
input {
  box-sizing: border-box;
  font-size: 16px;
  color: #000;
  font-weight: 400;
  margin: 0;
  padding: 12px 16px;
  height: 40px;
  width: 100%;
  outline: none;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
  @include border-radius(var(--radius-chat-inner-component));
  &:focus {
    border: 1px solid var(--bot-links-color);
  }
  &.input-invalid {
    border: 1px solid #e22c2c;
    background: url(/app/images/input-error.svg);
    background-position: 99%;
    background-repeat: no-repeat;
  }
}
</style>
